import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import WarehousesListTable from "../components/WarehousesListTable";
import "./WarehousesPage.scss";

const WarehousesPage = () => {
  const history = useHistory();
  const [refreshKey, setRefreshKey] = React.useState(Date.now());

  // Force refresh when returning to this page
  useEffect(() => {
    console.log("🏠 WarehousesPage mounted/refreshed");
    setRefreshKey(Date.now());
  }, []);

  const handleWarehouseSelect = (warehouse) => {
    // Navigate to the inventory management with warehouse ID as inventoryId
    history.push(`/warehouses/${warehouse.id}`);
  };

  const handleCreateWarehouse = () => {
    // Navigate to create warehouse page
    history.push("/warehouses/creation");
  };

  const handleEditWarehouse = (warehouse) => {
    // Navigate to edit warehouse page
    history.push(`/warehouses/edit/${warehouse.id}`);
  };

  return (
    <div className="client-warehouses-page">
      <WarehousesListTable
        key={refreshKey}
        onWarehouseSelect={handleWarehouseSelect}
        onCreateWarehouse={handleCreateWarehouse}
        onEditWarehouse={handleEditWarehouse}
      />
    </div>
  );
};

export default WarehousesPage;
